import Cookie from "js-cookie";
import { BUY_FLOW, BuyFlow } from "~/constants/buyFlow";
import clientSide from "~/helpers/clientSide";

export type CartExperienceRequestOptions = RequestInit & {
  buyFlowOverride?: BuyFlow;
};

export const getBuyFlowFromParam = (buyFlowParam?: string | string[] | null): BuyFlow | undefined => {
  const value = Array.isArray(buyFlowParam) ? buyFlowParam[0] : buyFlowParam;

  if (value === BUY_FLOW.NGC || value === BUY_FLOW.BAU) {
    return value;
  }

  return undefined;
};

export const getBuyFlowFromQueryParam = (): BuyFlow | undefined => {
  if (!clientSide || !window?.location?.search) {
    return undefined;
  }

  const buyFlowParam = new URLSearchParams(window.location.search).get("buyFlow");
  return getBuyFlowFromParam(buyFlowParam);
};

export const resolveBuyFlowForHeaders = (buyFlowOverride?: BuyFlow): BuyFlow => {
  if (buyFlowOverride === BUY_FLOW.NGC || buyFlowOverride === BUY_FLOW.BAU) {
    return buyFlowOverride;
  }

  const buyFlowFromQuery = getBuyFlowFromQueryParam();
  if (buyFlowFromQuery) {
    return buyFlowFromQuery;
  }

  const buyFlowCookie = Cookie.get("buyFlow");
  return getBuyFlowFromParam(buyFlowCookie) ?? BUY_FLOW.BAU;
};

export const withCartExperienceHeaders = (headers: HeadersInit, buyFlowOverride?: BuyFlow): HeadersInit => {
  const resolvedBuyFlow = resolveBuyFlowForHeaders(buyFlowOverride);

  return {
    ...headers,
    "x-ai-cart-experience": (resolvedBuyFlow === BUY_FLOW.NGC).toString(),
    "x-bau-cart-experience": (resolvedBuyFlow === BUY_FLOW.BAU).toString(),
  };
};
